import { IApplicationState } from '../../types/redux';

export const selectDailyrentPublicOfferAccepted = (state: IApplicationState) => state.dailyrentPublicOfferAccepted;
